import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';

// Theme Context
import { ThemeProvider } from './context/ThemeContext';

// Layout
import { Layout } from './components/layout';

// Pages
import {
  Home,
  Services,
  ServiceDetail,
  About,
  PortfolioPage,
  PortfolioDetail,
  Contact,
  ZoneIntervention,
  MentionsLegales,
  Confidentialite,
  CGV
} from './pages';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// 404 Page
function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] font-['Space_Grotesk']">
          404
        </h1>
        <p className="text-2xl text-white mb-8">Page non trouvée</p>
        <p className="text-gray-400 mb-8">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <a
          href="/"
          className="btn-magnetic px-8 py-4 bg-[var(--primary)] text-white font-bold rounded-xl inline-block"
        >
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <Routes>
          {/* Main Layout Routes */}
          <Route path="/" element={<Layout />}>
            {/* Home */}
            <Route index element={<Home />} />

            {/* Services */}
            <Route path="services" element={<Services />} />
            <Route path="services/:slug" element={<ServiceDetail />} />

            {/* Portfolio */}
            <Route path="portfolio" element={<PortfolioPage />} />
            <Route path="portfolio/:slug" element={<PortfolioDetail />} />

            {/* About */}
            <Route path="a-propos" element={<About />} />

            {/* Contact */}
            <Route path="contact" element={<Contact />} />

            {/* Zone d'intervention */}
            <Route path="zone-intervention/:slug" element={<ZoneIntervention />} />

            {/* Legal Pages */}
            <Route path="mentions-legales" element={<MentionsLegales />} />
            <Route path="confidentialite" element={<Confidentialite />} />
            <Route path="cgv" element={<CGV />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>

          {/* Analytics */}
          <Analytics />
        </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
